import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';


const importUserSettings = () => import(/* webpackChunkName: "user-settings" */ './containers/UserSettingsContainer');

const UserSettingsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importUserSettings}
      path={match.url}
    />
  </LoginRequiredContainer>
);

UserSettingsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default UserSettingsRoutes;
